module.exports = __webpack_public_path__ + "static/pubconfkcdc2018-131330a8453f7205e766c05e05938073.jpeg";